<mat-drawer-container class="drawer-container" fullscreen (backdropClick)="closeDrawer()">
    <!-- Site cards:  basic site details, site status, MAX point of contact, site roles. -->
    <mat-drawer-content>
        <h1>{{this.Site.name}}</h1>
        <div class="row wrapper">
            <div class="col-md-12">
                <app-site-details [site]="this.Site" (onEdit)="openEditor('details')"></app-site-details>
                <app-site-workflow-status [site]="this.Site" (onSave)="transitionWorkFlow($event)"></app-site-workflow-status>
                <!--***Use the following to display the 'Beta Feature Status' section on the Status Overview page-->
                <!--<app-site-beta-features [site]="this.Site" (onSave)="enableDisableBetaFeatures($event)"></app-site-beta-features>-->

                <!-- VNEXT-1066: KLW - Properties of the Banner -->
                <ng-container>
                    <app-configure-banner></app-configure-banner>
                </ng-container>

                <!-- Conditionally display a "Design Homepage ..." button. -->
                <!--<ng-container *ngIf="this.BetaFeaturesEnabled">-->
                    <app-configure-home-page></app-configure-home-page>
                <!--</ng-container>-->

                <div *ngIf="this.UserIsSystemAdmin" class="excel-site-import-label"><strong>Site-wide Excel Import:</strong></div>
                <div *ngIf="this.UserIsSystemAdmin" class="excel-site-structure-import-div">
                    <button mat-raised-button class="button-primary" (click)="this.importFromExcel(ImportSiteStructure)">Structure</button>&nbsp;
                    <button mat-raised-button class="button-primary" (click)="this.importFromExcel(ImportSiteFormInstances)">Forms</button>&nbsp;
                    <button mat-raised-button class="button-primary" (click)="this.importFromExcel(ImportFormInstanceGrids)">Grid Data</button>&nbsp;
                    <button mat-raised-button class="button-primary" (click)="this.importFromExcel(ImportValuesToFormInstances)">Values to Forms</button>
                </div>

                <div *ngIf="this.UserIsSystemAdmin" class="excel-site-import-label"><strong>Site-wide Excel Export:</strong></div>
                <div *ngIf="this.UserIsSystemAdmin" class="excel-site-structure-import-div">
                    <button mat-raised-button class="button-primary" (click)="this.exportToExcel()">Form Data</button>&nbsp;
                </div>

                <div *ngIf="true"
                     class="excel-site-structure-import-div"
                     style="margin-top: 15px;">
                    <button mat-raised-button color="primary" (click)="this.configureStructureFields()">Configure Structure Fields</button>&nbsp;
                </div>

                <div *ngIf="this.UserIsSystemAdmin"
                     class="excel-site-structure-import-div"
                     style="margin-top: 15px;">
                    <button mat-raised-button color="primary" (click)="this.generateSiteETLMetadataClicked()">Generate Site Data Mart</button>&nbsp;
                </div>
            </div>
            <!--10/1/2024 | JJ - Commented out in order to hide the beta features on the status overview page | vnext-1052-->
            <!--<div class="col-md-5">-->
                <!-- 08-29-2022 note:  moved the functionality for setting a MAX point of contact into the site details component. -->
                <!--<app-site-contacts [site]="this.Site" (onEdit)="openEditor('contacts')"></app-site-contacts>-->

                <!--10/1/2024 | JJ - Removed so since we only want simple permissions to be used | vnext-1052-->
                <!--<ng-container *ngIf="!this.UseSimplifiedPermissionsModel">
                    <app-site-roles [roles]="this.Site.roles"
                                    (new)="openRolesViewer()"
                                    (edit)="openRolesViewer()"></app-site-roles>
                </ng-container>-->

                <!--<app-site-milestones #siteMilestones
                                     [site]="this.Site"
                                     [editMode]="true"
                                     [isSiteLevelAccess]="true"
                                     (onEdit)="openMilestones($event)"></app-site-milestones>-->

                <!--<app-site-beta-features [site]="this.Site" (onSave)="enableDisableBetaFeatures($event)"></app-site-beta-features>-->

                <!--<app-toggle-site-permission-model *ngIf="this.UserIsSystemAdmin"
                                                  (onSetPermissionsModel)="this.setSitePermissionsModel($event)"></app-toggle-site-permission-model>-->
            <!--</div>-->
        </div>
    </mat-drawer-content>

    <!-- Side drawer. -->
    <mat-drawer [opened]="this.ShowSiteEditor || this.ShowRolesViewer || this.ShowMilestonesViewer"
                #editorDrawer
                mode="over"
                position="end"
                (keydown.escape)="closeDrawer()"
                disableClose>
        <div id="drawer-keyboard-focus-div" tabindex="-1"></div>

        <!-- Use a mat-toolbar to display the drawer's title. -->
        <mat-toolbar>
            <span *ngIf="this.ShowSiteEditor && this.SelectedCard=='contacts'">Site Point of Contact</span>
            <span *ngIf="this.ShowSiteEditor && this.SelectedCard=='details'">Site Details</span>
            <span *ngIf="this.ShowRolesViewer">Site Roles</span>
            <span *ngIf="this.ShowMilestonesViewer">Site Milestones</span>
            <span class="info-drawer-toolbar-spacer"></span>
            <button mat-icon-button (click)="closeDrawer()" tabindex="-1"><mat-icon>close</mat-icon></button>
        </mat-toolbar>

        <!-- Display the drawer content that the user can edit. -->
        <div [ngClass]="{'properties-drawer':this.ShowSiteEditor, 'roles-drawer':this.ShowRolesViewer, 'milestones-drawer': this.ShowMilestonesViewer}">
            <app-site-editor *ngIf="this.ShowSiteEditor"
                             [site]="this.Site"
                             [display]="this.SelectedCard"
                             (siteSaved)="doUpdate($event)"
                             (editCanceled)="this.ShowSiteEditor=false">
            </app-site-editor>

            <app-role-viewer *ngIf="this.ShowRolesViewer && this.Roles"
                             [roles]="this.Roles"
                             [folderOrSitelevel]="'site'"
                             [folderId]="this.RootFolderId"
                             [siteId]="this.Site.id"
                             [title]="this.Site.name"
                             (close)="this.ShowRolesViewer=false"></app-role-viewer>

            <app-site-milestones *ngIf="this.ShowMilestonesViewer"
                                 [site]="this.Site"
                                 [editMode]="true"
                                 [isSiteLevelAccess]="true"
                                 (close)="this.ShowMilestonesViewer=false"></app-site-milestones>
        </div>
    </mat-drawer>
</mat-drawer-container>

